// 导入 AES 加密函数
import { encryptAES } from '@/utils/crypto'
import store from '@/store'

// 定义接口类型
interface QueryParams {
    [key: string]: string
}

interface MathTokenResult {
    token: string
    tokenParam: string
    tokenData: string
    tokenSign: string
}

export const sortQueryString = (url: string): string => {
    const queryString = url.split('?')[1] || ''
    const params: QueryParams = {}

    queryString.split('&').forEach((pair: string) => {
        const [key, value] = pair.split('=')

        if (key) {
            params[decodeURIComponent(key)] = decodeURIComponent(value || '')
        }
    })

    const sortedKeys = Object.keys(params).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
    const sortedQueryString = sortedKeys.map(key => `${encodeURIComponent(key).toLowerCase()}=${encodeURIComponent(params[key])}`).join('&')

    return sortedQueryString
}

export const mathTokens = (timespan: number | string, urlWithParam: string): MathTokenResult => {
    let tokenParam = timespan + '',
        tokenParam32 = tokenParam.padEnd(32, '0'),
        token = store.getters['user/token'] || '',
        token32 = token.length > 32 ? token.substr(0, 32) : token.padEnd(32, '0'),
        sortUrlQueryString = sortQueryString(urlWithParam)

    return {
        token,
        tokenParam,
        tokenData: encryptAES(token32, tokenParam32),
        tokenSign: encryptAES(sortUrlQueryString, token32)
    }
}
